import { render } from "./twoFactorAuth.vue?vue&type=template&id=2ac27f0c"
import script from "./twoFactorAuth.vue?vue&type=script&lang=js"
export * from "./twoFactorAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__